export class Company {
  companyId?: number;

  name?: string;

  brand?: string;

  address?: string;

  color?: string;

  textColor?: string;
  phone?: string;
  email?: string;
  type?: string;
  serviceCount?: number;
}
